import { vars, InfoButton, Tooltip, Text } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { buttonInfo } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStatusData = (departureAirport, isAirportAvailable, isCardSelected, addedStatus, availableStatus, unavailableStatus, statusTooltip) => {
  if (isCardSelected && isAirportAvailable) {
    return {
      text: addedStatus,
      icon: /*#__PURE__*/_jsx(CheckCircle, {
        "aria-hidden": true,
        color: vars.colors.signal.positive.foreground,
        "data-testid": "add-icon",
        size: 20,
        weight: "regular"
      })
    };
  }
  if (isAirportAvailable) {
    return {
      text: availableStatus
    };
  }
  return {
    text: unavailableStatus,
    icon: /*#__PURE__*/_jsx(Tooltip, {
      "aria-live": "polite",
      content: statusTooltip,
      title: "tooltip",
      trigger: "click",
      children: /*#__PURE__*/_jsx(InfoButton, {
        className: buttonInfo,
        color: vars.colors.signal.caution.foreground,
        "data-testid": "unavailable-icon",
        label: `${departureAirport} ${unavailableStatus}`
      })
    })
  };
};
const AvailabilityStatus = ({
  departureAirport,
  addedStatus,
  availableStatus,
  unavailableStatus,
  statusTooltip,
  isAirportAvailable,
  isCardSelected
}) => {
  const statusData = useStatusData(departureAirport, isAirportAvailable, isCardSelected, addedStatus, availableStatus, unavailableStatus, statusTooltip);
  return /*#__PURE__*/_jsxs("div", {
    className: "airportStatus",
    children: [/*#__PURE__*/_jsx(Text, {
      className: "statusText",
      children: statusData.text
    }), statusData.icon]
  });
};
export default AvailabilityStatus;
//# sourceMappingURL=AvailabilityStatus.js.map